/**
 * Safely push data to Google Tag Manager's data layer.
 * @param {...Object} events Object(s) with fields to push to Google Tag Manager data layer.
 * @deprecated Please use `@bombas/hive` instead.
 */
export var trackEvent = function () {
    var _a;
    var events = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        events[_i] = arguments[_i];
    }
    if (typeof window === 'undefined' || !events.length)
        return;
    window.dataLayer = window.dataLayer || [];
    (_a = window.dataLayer).push.apply(_a, events);
};
export default {};
